<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaContact')}} </h4>
        </div>
        <form class="add-user-form" id="edit-contact" method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                          <input type="text" class="form-control"
                                 placeholder=""
                                 :readonly="assigned == true && input_field.inputName == 'company_name'"
                                 v-validate="input_field.validationRules"
                                 :data-vv-as="input_field.labelName"
                                 v-model="input_field.inputValue"
                                 v-bind:name="input_field.inputName"
                                 v-bind:id="input_field.inputName">
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                              <i v-bind:class="input_field.icon"></i>
                          </span>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               v-model="input_field.inputValue"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                            <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea v-model="this.notes" :placeholder="$t('placeholder.notite')" name='notes'></textarea>
                        <div class="save-contact-buttons">
                            <button @click.prevent='saveContact()' :disabled="this.$store.state.loading">
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ContactsService from '../../api-services/contacts.service.js'
export default {
  name: 'EditContact',
  data () {
    return {
      contact: null,
      notes: null,
      assigned: false
    }
  },
  methods: {
    getContact () {
      ContactsService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.contact = response.data.data
          this.notes = this.contact.notes
          this.assigned = !!(this.contact.user)
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    saveContact () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-contact'))
      // if (this.select_county) {
      //   formData.append('county', this.select_county.id)
      // }
      ContactsService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.contact = response.data.data
          this.notes = this.contact.notes
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.contactModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.contact) ? this.contact.name : null,
            icon: 'fas fa-user',
            validationRules: ''
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.contact) ? ((this.contact.user != null) ? this.contact.user.company_name : this.contact.company_name) : '',
            icon: 'fas fa-building',
            validationRules: ''
          },
          {
            inputName: 'function',
            labelName: this.$t('placeholder.functie'),
            inputValue: (this.contact) ? this.contact.function : null,
            icon: 'fas fa-user-tie',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.contact) ? this.contact.phone : null,
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.contact) ? this.contact.email : null,
            icon: 'fas fa-envelope',
            validationRules: 'email'
          }
        ]
      }
    }
  },
  async created () {
    await this.getContact()
    this.$store.dispatch('hideLoading')
  }
}
</script>
